var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tab_content_area", attrs: { id: "tab2" } }, [
    _vm._m(0),
    _c("div", { staticClass: "container_tbl_wrap" }, [
      _c("div", { staticClass: "tbl_tit" }, [
        _vm._v(_vm._s(_vm.$t("msg.NEWB010P050.005"))),
      ]),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "img_wrap", staticStyle: { height: "300px" } },
      [
        _c("img", {
          attrs: { src: require("../../../assets/images/trans/con_rf.png") },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tbl_wrap" }, [
      _c("table", { staticClass: "tbl_col" }, [
        _c("colgroup", [
          _c("col", { staticStyle: { width: "14%" } }),
          _c("col", { staticStyle: { width: "auto" } }),
          _c("col", { staticStyle: { width: "14%" } }),
          _c("col", { staticStyle: { width: "14%" } }),
          _c("col", { staticStyle: { width: "14%" } }),
          _c("col", { staticStyle: { width: "14%" } }),
          _c("col", { staticStyle: { width: "14%" } }),
        ]),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Type of "),
              _c("br"),
              _vm._v("Container"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Internal"),
              _c("br"),
              _vm._v("Dimension"),
              _c("br"),
              _vm._v("(mm)"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Door"),
              _c("br"),
              _vm._v("Opening"),
              _c("br"),
              _vm._v("(mm)"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Load"),
              _c("br"),
              _vm._v("Capacity"),
              _c("br"),
              _vm._v("(m"),
              _c("sup", [_vm._v("3")]),
              _vm._v(")"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Container"),
              _c("br"),
              _vm._v("Tare Weight"),
              _c("br"),
              _vm._v("(Kg)"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Max "),
              _c("br"),
              _vm._v("Pay Load"),
              _c("br"),
              _vm._v("(Kg)"),
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("Max "),
              _c("br"),
              _vm._v("Gross Weight"),
              _c("br"),
              _vm._v("(Kg)"),
            ]),
          ]),
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("20RF")]),
            _c("td", [
              _vm._v("L: 5,454"),
              _c("br"),
              _vm._v("W: 2,286"),
              _c("br"),
              _vm._v("H: 2,245"),
            ]),
            _c("td", [_vm._v("W: 2,286"), _c("br"), _vm._v("H: 2,16")]),
            _c("td", [_vm._v("28.5")]),
            _c("td", [_vm._v("3,000")]),
            _c("td", [_vm._v("22,000")]),
            _c("td", [_vm._v("25,000")]),
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("40RF")]),
            _c("td", [
              _vm._v("L: 11,583"),
              _c("br"),
              _vm._v("W: 2,286"),
              _c("br"),
              _vm._v("H: 2,215"),
            ]),
            _c("td", [_vm._v("W: 2,294"), _c("br"), _vm._v("H: 2,248")]),
            _c("td", [_vm._v("58.7")]),
            _c("td", [_vm._v("4,700")]),
            _c("td", [_vm._v("25,780")]),
            _c("td", [_vm._v("30,480")]),
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("40HCRF")]),
            _c("td", [
              _vm._v("L: 11,583"),
              _c("br"),
              _vm._v("W: 2,290"),
              _c("br"),
              _vm._v("H: 2,542"),
            ]),
            _c("td", [_vm._v("W: 2,290"), _c("br"), _vm._v("H: 2,507")]),
            _c("td", [_vm._v("67.4")]),
            _c("td", [_vm._v("4,750")]),
            _c("td", [_vm._v("25,780")]),
            _c("td", [_vm._v("30,480")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }